import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { MultiTabPanelHeaderItemProps } from './panels.props';
import { IClassMap } from '../helpers';
import { classMap } from 'lit/directives/class-map.js';
import * as TagNames from './panels.tagnames';
import { AtlMultiTabChangeEvent } from './panel.events';

@customElement(TagNames.MultiTabHeaderItem)
export class AtlMultiTabPanelHeaderItem
   extends LitElement
   implements MultiTabPanelHeaderItemProps
{
   declare id: string;
   declare headerClassName: string;
   declare activeTabId: string;

   static properties = {
      id: { type: String },
      headerClassName: { type: String },
      activeTabId: { type: String },
   };

   constructor() {
      super();
      this.headerClassName = '';
      this.activeTabId = '';
   }

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      const listClass: IClassMap = {
         'nav-item': true,
      };
      if (this.headerClassName) {
         listClass[this.headerClassName] = true;
      }

      return html`
         <div class="atl-wc-nav-tab-item">
            <li
               class=${classMap(listClass)}
               role="tab"
               aria-selected=${this.activeTabId === this.id}
               key=${this.id}
            >
               <a
                  class=${classMap({
                     'nav-link': true,
                     active: this.activeTabId === this.id,
                  })}
                  id=${`nav-${this.id}`}
                  data-bs-toggle="tab"
                  data-bs-target=${`#${this.id}`}
                  @click=${this._handleTabChange}
                  role="button"
                  @keydown=${this._handleTabChange}
               >
                  <slot></slot>
               </a>
            </li>
         </div>
      `;
   }

   private _handleTabChange = () =>
      this.dispatchEvent(new AtlMultiTabChangeEvent({ tabId: this.id }));
}
